import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Button from "../Button";

const Header = ({ onOpenEstimate }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="sticky top-0 z-40 bg-white shadow-sm px-6 py-4 flex items-center justify-between">
      <Link to="/" className="text-xl font-bold text-green-700">
        LawnSmartPro
      </Link>

      {/* Desktop nav */}
      <div className="hidden sm:flex gap-6 items-center">
        <Link
          to="/services/lawn-maintenance"
          className="text-sm text-gray-700 hover:text-green-600"
        >
          Lawn
        </Link>
        <Link
          to="/services/landscaping"
          className="text-sm text-gray-700 hover:text-green-600"
        >
          Landscaping
        </Link>
        <Link
          to="/services/irrigation"
          className="text-sm text-gray-700 hover:text-green-600"
        >
          Irrigation
        </Link>
        <Button onClick={onOpenEstimate}>Get Estimate</Button>
      </div>

      {/* Mobile menu toggle */}
      <button onClick={toggleMenu} className="sm:hidden text-green-700">
        {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {/* Mobile nav */}
      {menuOpen && (
        <div className="absolute top-16 left-0 w-full bg-white shadow-md p-6 space-y-4 sm:hidden">
          <Link to="/" className="block text-gray-700" onClick={toggleMenu}>
            Home
          </Link>
          <Link
            to="/services/lawn-maintenance"
            className="block text-gray-700"
            onClick={toggleMenu}
          >
            Lawn Maintenance
          </Link>
          <Link
            to="/services/landscaping"
            className="block text-gray-700"
            onClick={toggleMenu}
          >
            Landscaping
          </Link>
          <Link
            to="/services/irrigation"
            className="block text-gray-700"
            onClick={toggleMenu}
          >
            Irrigation
          </Link>
          <button
            onClick={() => {
              toggleMenu();
              onOpenEstimate();
            }}
            className="w-full bg-green-600 text-white py-2 rounded"
          >
            Get Estimate
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
